import React from 'react';
import { Modal, Spinner } from 'react-bootstrap';

const LoaderModal = ({ show, handleClose, text = "Loading" }) => {

    return (
        <Modal show={show} onHide={handleClose} backdrop="static" keyboard={false} centered size='sm'>
            <Modal.Body>
                <div className='d-flex gap-2 justify-content-center align-items-center'>
                    <Spinner size='sm' className='text-primary' />
                    <span>{text}</span>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default LoaderModal;
